import { render } from "./archiveWidget.vue?vue&type=template&id=60e7b9b0&scoped=true"
import script from "./archiveWidget.vue?vue&type=script&lang=js"
export * from "./archiveWidget.vue?vue&type=script&lang=js"

import "./archiveWidget.vue?vue&type=style&index=0&id=60e7b9b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60e7b9b0"]])

export default __exports__